<template>
  <div class="form-group">
    <div class="row">
      <div v-if="!offline" class="col-9">
        <vue-slider
          tooltip="false"
          :min="min"
          :max="max"
          step="1"
          :id="id"
          v-model="rangeValue"
          :enableCross="false"
          @input="emit"
        ></vue-slider>
        <label :for="id">{{ rangeValue[0] }} - {{ rangeValue[1] }}</label>
      </div>
      <div :class="[offline ? 'col-12' : 'col-3']">
        <div class="custom-control custom-checkbox">
          <input
            class="custom-control-input"
            type="checkbox"
            :name="attribute.name"
            :id="attribute.name"
            v-model="offline"
            @input="emit"
            @change="emit"
          />
          <label
            v-tooltip:top="tooltip"
            class="custom-control-label"
            :for="attribute.name"
            >{{ content }}</label
          >
        </div>
      </div>
    </div>
    <div
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>

<script>
import { uniqueId } from "lodash";

export default {
  data() {
    return {
      rangeValue: [0, 1],
      offline: false,
      id: uniqueId()
    };
  },
  mounted() {
    if (this.value === true) {
      this.offline = true;
      this.rangeValue = [this.min, this.max];
    } else if (this.value) {
      this.offline = false;
      this.rangeValue = [this.value[0], this.value[1]];
    } else {
      this.offline = false;
      this.rangeValue = [this.min, this.max];
    }
    this.emit;
  },
  computed: {
    max() {
      return this.attribute.max;
    },
    min() {
      return this.attribute.min;
    },
    tooltip() {
      return `Es werden nur Mitglieder angeschrieben, die länger als ${Laravel.settings.circularmailOfflineDays} Tage offline sind`;
    },
    content() {
      return this.offline
        ? this.tooltip
        : `nur mehr als ${Laravel.settings.circularmailOfflineDays} Tage offline`;
    }
  },
  methods: {
    emit() {
      if (this.offline) {
        this.$emit("input", true);
      } else {
        this.$emit("input", {
          min: this.rangeValue[0],
          max: this.rangeValue[1]
        });
      }
    }
  },
  props: {
    value: {
      required: true
    },
    attribute: {
      required: true,
      type: Object
    }
  }
};
</script>
